import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import styles from './agents.module.scss';
export class AgentNumbers extends Component {
    render() {
        const { icon, tooltipInfix, available, online } = this.props;
        return (_jsxs("div", Object.assign({ className: styles.numbers }, { children: [_jsx(Icon, { className: styles.icon, name: icon }), _jsx(Tooltip, Object.assign({ content: `Available ${tooltipInfix} agents`, dark: true }, { children: _jsx("span", { children: available }) })), online !== null && (_jsxs(_Fragment, { children: [_jsx("span", { children: "/" }), _jsx(Tooltip, Object.assign({ content: `Online ${tooltipInfix} agents`, dark: true }, { children: _jsx("span", { children: online }) }))] }))] })));
    }
}
/**
 * Configurations for channels to be displayed in the agents column of the
 * dashboard overview.
 */
export const CHANNELS_CONFIG = [
    {
        channel: 'pstn_phone',
        icon: 'phone',
        tooltipInfix: 'phone',
    },
    {
        channel: 'widget_chat',
        icon: 'chat',
        tooltipInfix: 'chat',
    },
    {
        channel: 'email',
        icon: 'mail',
        tooltipInfix: 'email and contact form',
    },
    {
        channel: 'facebook_messenger',
        icon: 'facebook-messenger',
        tooltipInfix: 'messaging',
    },
];
export class Agents extends Component {
    render() {
        const { available_agents, online_agents } = this.props.dashboardQueue;
        return (_jsx("div", Object.assign({ className: styles.channels }, { children: CHANNELS_CONFIG.map(({ channel, tooltipInfix, icon }) => {
                var _a, _b;
                const online = (_a = online_agents[channel]) !== null && _a !== void 0 ? _a : 0;
                const available = (_b = available_agents[channel]) !== null && _b !== void 0 ? _b : 0;
                if (!online) {
                    return null;
                }
                const agentNumberProps = {
                    icon,
                    tooltipInfix,
                    available,
                    online,
                };
                return _jsx(AgentNumbers, Object.assign({}, agentNumberProps), channel);
            }) })));
    }
}
